/**
 * Utility functions to resolve user IDs to user names
 */

import { User } from '../services/user';

/**
 * Create a map from user ID to user full name
 */
export function createUserIdToNameMap(users: User[]): Map<number, string> {
  const map = new Map<number, string>();
  users.forEach(user => {
    map.set(user.id, user.full_name || user.username);
  });
  return map;
}

/**
 * Resolve a team name that could be either a number (user ID) or string (name or stringified ID)
 */
export function resolveTeamName(
  teamName: string | number,
  userIdToNameMap: Map<number, string>
): string {
  // If it's already a number, resolve it directly
  if (typeof teamName === 'number') {
    return userIdToNameMap.get(teamName) || `User ${teamName}`;
  }
  
  // If it's a string, check if it's a numeric string (like "126")
  const numericValue = Number(teamName);
  if (!isNaN(numericValue) && isFinite(numericValue) && teamName.trim() === String(numericValue)) {
    // It's a string representation of a number, treat it as a user ID
    const resolvedName = userIdToNameMap.get(numericValue);
    if (resolvedName) {
      return resolvedName;
    }
  }
  
  // Otherwise, it's a regular string name, return as-is
  return teamName;
}

